export default __webpack_public_path__ + "static/media/revospid_promo_app.f18866c8.png";